import { registerPlugin } from '@capacitor/core';

import type { SecurekeyPlugin } from './definitions';

const Securekey = registerPlugin<SecurekeyPlugin>('Securekey', {
  web: () => import('./web').then((m) => new m.SecurekeyWeb()),
});

export * from './definitions';
export { Securekey };
